export default __webpack_public_path__ + "static/media/char_body_012.82f1a7a3.png";